<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-2">
<p class="noindenttR"><span class="bold"><em class="italic">Cover image:</em> Bombing Up</span> - Short Stirling <em class="italic">by Michael Turner FGAvA (President)</em> Gouache</p>
<p class="noindent1R">Plus thumbnail images from Anthony Cowland FGAvA, Chris French FGAvA, Ron Wong FGAvA, Keith Woodcock FGAvA, Denis Pannett FGAvA, and Frank Wootton OBE FPGAvA</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002_FM1.vue?5634354b